module.exports = __webpack_public_path__ + "static/media/tallink-silja.f72ee5e4.svg";